import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import App from './components/app';
import ErrorBoundary from './components/common/ErrorBoundary';
import RouteErrorFallback from './components/common/RouteErrorFallback';

const PendingRoute = ({ component: Component, auth, user, ...rest }) => {
  const boundaryName = Array.isArray(rest.path) ? rest.path.join('|') : (rest.path || Component.displayName || Component.name || 'pending-route');

  return (
    <App request={(action, data, method = 'GET') => rest.request(action, data, method)}>
      <ErrorBoundary
        name={`route:${boundaryName}`}
        fallback={(error, reset) => <RouteErrorFallback error={error} onRetry={reset} />}
      >
        <Route
          {...rest}
          render={(props) =>
            !auth ? (
              <Redirect
                to={{
                  pathname: '/login',
                  state: { from: props.location },
                }}
              />
            ) : (
              <Component {...props} request={(action, data, method = 'POST') => rest.request(action, data, method)} />
            )
          }
        />
      </ErrorBoundary>
    </App>
  );
};

const mapStateToProps = (state) => ({
  auth: state.Auth.auth,
  user: state.Auth.user,
});

export default connect(mapStateToProps)(PendingRoute);